import { useEffect, useState } from "react";

import Link from "next/link";
import { useRouter } from "next/router";

import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";

import { DropDownArrowIcon } from "@/components/data-display/icon";

function Category({ categoryData }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { query } = useRouter();
  const selectedSlug = query?.slug;

  const isSelected = selectedSlug === categoryData?.slug;
  const isChildAvailable = categoryData.child.length > 0;
  const isChildSelected =
    isChildAvailable &&
    categoryData.child.some((el) => el.slug === selectedSlug);

  useEffect(() => {
    if (isChildSelected) {
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
    }
  }, [query]);

  return (
    <div>
      <div
        className={classNames(
          {
            "text-primary": isSelected || isChildSelected,
            "text-grayDisplay-700": !isSelected,
          },
          `flex cursor-pointer items-center justify-between gap-3`
        )}
        key={categoryData.slug}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isChildAvailable ? (
          <>
            <p>{categoryData.name}</p>

            {isChildAvailable && (
              <div className="h-[1rem] w-[1rem]">
                <DropDownArrowIcon
                  className={classNames(
                    { "rotate-180": isMenuOpen },
                    `h-[1rem] w-[1rem]`
                  )}
                />
              </div>
            )}
          </>
        ) : (
          <Link href={`/category/${categoryData?.slug}`}>
            {categoryData.name}
          </Link>
        )}
      </div>
      <AnimatePresence>
        {isMenuOpen && isChildAvailable && (
          <motion.div
            exit={{ height: 0 }}
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            className={`overflow-hidden`}
            transition={{ duration: 0.3, delay: 0.1 }}
          >
            <div className="space-y-[1.15rem] pl-[1rem] pt-[1.25rem]">
              {categoryData.child.map((childCategory) => (
                <motion.div
                  key={childCategory.slug}
                  className={classNames({
                    "text-primary": selectedSlug === childCategory.slug,
                    "text-grayDisplay-700": selectedSlug !== childCategory.slug,
                  })}
                >
                  <Link href={`/category/${childCategory?.slug}`}>
                    {childCategory.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Category;
